
import * as d2FzbTpqcy1zdHJpbmc from './Awake-samples-ui-showcase.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUShortToJsNumberUnsafe' : (x) => x & 0xFFFF,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'org.khronos.webgl.getMethodImplForInt32Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int32Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int32Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.css.cssText_$external_prop_setter' : (_this, v) => _this.cssText = v,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.width_$external_prop_getter_1' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter_1' : (_this) => _this.height,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.touches_$external_prop_getter' : (_this) => _this.touches,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'js.array.get_$external_fun' : (_this, i) => _this[i],
    'js.buffer.ArrayBuffer_$external_fun' : (p0, p1, isDefault0) => new ArrayBuffer(p0, isDefault0 ? undefined : p1, ),
    'js.buffer.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'js.collections.JsMap_$external_fun' : (p0, isDefault0) => new Map(isDefault0 ? undefined : p0, ),
    'js.collections.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'js.collections.has_$external_fun' : (_this, p0) => _this.has(p0),
    'js.promise.then_$external_fun' : (_this, p0, p1) => _this.then(p0, p1),
    'js.typedarrays.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'js.typedarrays.length_$external_prop_getter' : (_this) => _this.length,
    'web.gpu.getPreferredCanvasFormat_$external_fun' : (_this, ) => _this.getPreferredCanvasFormat(),
    'web.navigator.gpu_$external_prop_getter' : (_this) => _this.gpu,
    'web.gpu.Companion_$external_object_getInstance' : () => GPUCanvasContext,
    'web.gpu.GPUCanvasContext_$external_class_instanceof' : (x) => x instanceof GPUCanvasContext,
    'web.gpu.GPUCanvasContext_$external_class_get' : () => GPUCanvasContext,
    'web.html.height_$external_prop_getter' : (_this) => _this.height,
    'web.html.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'web.html.width_$external_prop_getter' : (_this) => _this.width,
    'web.html.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'web.html.getContext_$external_fun' : (_this, p0, p1, isDefault0) => _this.getContext(p0, isDefault0 ? undefined : p1, ),
    'web.navigator.navigator_$external_prop_getter' : () => navigator,
    'com.awakekt.awake.engine.window.reportBrowserFrameFailure' : (message) => console.error(message),
    'com.awakekt.awake.engine.window.reportBrowserStartupFailure' : (message) => console.error(message),
    'com.awakekt.awake.engine.window.safeAreaOf' : (canvas) => {
        let probe = document.getElementById('awake-safe-area-probe');
        if (!probe) {
            probe = document.createElement('div');
            probe.id = 'awake-safe-area-probe';
            probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
                'padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)';
            document.body.appendChild(probe);
        }
        const style = getComputedStyle(probe);
        const box = canvas.getBoundingClientRect();
        const left = parseFloat(style.paddingLeft) - box.left;
        const top = parseFloat(style.paddingTop) - box.top;
        const right = parseFloat(style.paddingRight) - (window.innerWidth - box.right);
        const bottom = parseFloat(style.paddingBottom) - (window.innerHeight - box.bottom);
        return [left, top, right, bottom].join(',');
    },
    'com.awakekt.awake.engine.window.compositionData' : (event) => typeof event.data === 'string' ? event.data : null,
    'com.awakekt.awake.engine.window.pastedText' : (event) => event.clipboardData ? event.clipboardData.getData('text/plain') : null,
    'com.awakekt.awake.engine.window.writeClipboardText' : (text) => { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).catch((e) => console.warn('Awake: clipboard write failed', e)); },
    'com.awakekt.awake.engine.window.focusWithoutScrolling' : (element) => element.focus({ preventScroll: true }),
    'com.awakekt.awake.engine.window.isComposing' : (event) => event.isComposing === true || event.keyCode === 229,
    'com.awakekt.awake.engine.window.browserGamepadButtons' : () => {
        const pads = navigator.getGamepads ? navigator.getGamepads() : [];
        for (const pad of pads) {
            if (!pad || !pad.connected || pad.mapping !== "standard") continue;
            let bits = 0;
            for (let i = 0; i < pad.buttons.length && i < 31; i++) if (pad.buttons[i].pressed) bits |= 1 << i;
            return bits;
        }
        return -1;
    },
    'com.awakekt.awake.engine.window.gestureClientX' : (event) => typeof event.clientX === 'number' ? event.clientX : NaN,
    'com.awakekt.awake.engine.window.gestureClientY' : (event) => typeof event.clientY === 'number' ? event.clientY : NaN,
    'com.awakekt.awake.engine.window.gestureScale' : (event) => typeof event.scale === 'number' ? event.scale : NaN,
    'com.awakekt.awake.engine.window.addNonPassiveListener' : (type, listener) => window.addEventListener(type, listener, { passive: false }),
    'io.ygdrasil.webgpu.toULong' : (ref) => BigInt(ref),
    'io.ygdrasil.webgpu.requestAdapter_$external_fun' : (_this, ) => _this.requestAdapter(),
    'io.ygdrasil.webgpu.requestAdapter_$external_fun_1' : (_this, p0) => _this.requestAdapter(p0),
    'io.ygdrasil.webgpu.gpu_$external_prop_getter' : (_this) => _this.gpu,
    'io.ygdrasil.webgpu.navigator_$external_object_getInstance' : () => navigator,
    'io.ygdrasil.webgpu.createJsObject' : () => ({ }),
    'io.ygdrasil.webgpu.canvas_$external_prop_getter' : (_this) => _this.canvas,
    'io.ygdrasil.webgpu.configure_$external_fun' : (_this, p0) => _this.configure(p0),
    'io.ygdrasil.webgpu.getCurrentTexture_$external_fun' : (_this, ) => _this.getCurrentTexture(),
    'io.ygdrasil.webgpu.submit_$external_fun' : (_this, p0) => _this.submit(p0),
    'io.ygdrasil.webgpu.writeBuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.writeBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.writeBuffer_$external_fun_1' : (_this, p0, p1, p2, p3, p4) => _this.writeBuffer(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.writeTexture_$external_fun' : (_this, p0, p1, p2, p3) => _this.writeTexture(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.setViewport_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.setViewport(p0, p1, p2, p3, p4, p5),
    'io.ygdrasil.webgpu.setScissorRect_$external_fun' : (_this, p0, p1, p2, p3) => _this.setScissorRect(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.end_$external_fun' : (_this, ) => _this.end(),
    'io.ygdrasil.webgpu.createView_$external_fun' : (_this, ) => _this.createView(),
    'io.ygdrasil.webgpu.createView_$external_fun_1' : (_this, p0) => _this.createView(p0),
    'io.ygdrasil.webgpu.destroy_$external_fun' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.mapAsync_$external_fun' : (_this, p0, p1) => _this.mapAsync(p0, p1),
    'io.ygdrasil.webgpu.mapAsync_$external_fun_1' : (_this, p0, p1, p2) => _this.mapAsync(p0, p1, p2),
    'io.ygdrasil.webgpu.getMappedRange_$external_fun' : (_this, p0) => _this.getMappedRange(p0),
    'io.ygdrasil.webgpu.getMappedRange_$external_fun_1' : (_this, p0, p1) => _this.getMappedRange(p0, p1),
    'io.ygdrasil.webgpu.unmap_$external_fun' : (_this, ) => _this.unmap(),
    'io.ygdrasil.webgpu.destroy_$external_fun_1' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.message_$external_prop_getter' : (_this) => _this.message,
    'io.ygdrasil.webgpu.features_$external_prop_getter' : (_this) => _this.features,
    'io.ygdrasil.webgpu.limits_$external_prop_getter' : (_this) => _this.limits,
    'io.ygdrasil.webgpu.queue_$external_prop_getter' : (_this) => _this.queue,
    'io.ygdrasil.webgpu.destroy_$external_fun_2' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.createBuffer_$external_fun' : (_this, p0) => _this.createBuffer(p0),
    'io.ygdrasil.webgpu.createTexture_$external_fun' : (_this, p0) => _this.createTexture(p0),
    'io.ygdrasil.webgpu.createSampler_$external_fun' : (_this, ) => _this.createSampler(),
    'io.ygdrasil.webgpu.createSampler_$external_fun_1' : (_this, p0) => _this.createSampler(p0),
    'io.ygdrasil.webgpu.createBindGroupLayout_$external_fun' : (_this, p0) => _this.createBindGroupLayout(p0),
    'io.ygdrasil.webgpu.createPipelineLayout_$external_fun' : (_this, p0) => _this.createPipelineLayout(p0),
    'io.ygdrasil.webgpu.createBindGroup_$external_fun' : (_this, p0) => _this.createBindGroup(p0),
    'io.ygdrasil.webgpu.createShaderModule_$external_fun' : (_this, p0) => _this.createShaderModule(p0),
    'io.ygdrasil.webgpu.createRenderPipeline_$external_fun' : (_this, p0) => _this.createRenderPipeline(p0),
    'io.ygdrasil.webgpu.createCommandEncoder_$external_fun' : (_this, ) => _this.createCommandEncoder(),
    'io.ygdrasil.webgpu.createCommandEncoder_$external_fun_1' : (_this, p0) => _this.createCommandEncoder(p0),
    'io.ygdrasil.webgpu.createQuerySet_$external_fun' : (_this, p0) => _this.createQuerySet(p0),
    'io.ygdrasil.webgpu.features_$external_prop_getter_1' : (_this) => _this.features,
    'io.ygdrasil.webgpu.limits_$external_prop_getter_1' : (_this) => _this.limits,
    'io.ygdrasil.webgpu.requestDevice_$external_fun' : (_this, ) => _this.requestDevice(),
    'io.ygdrasil.webgpu.requestDevice_$external_fun_1' : (_this, p0) => _this.requestDevice(p0),
    'io.ygdrasil.webgpu.maxTextureDimension1D_$external_prop_getter' : (_this) => _this.maxTextureDimension1D,
    'io.ygdrasil.webgpu.maxTextureDimension2D_$external_prop_getter' : (_this) => _this.maxTextureDimension2D,
    'io.ygdrasil.webgpu.maxTextureDimension3D_$external_prop_getter' : (_this) => _this.maxTextureDimension3D,
    'io.ygdrasil.webgpu.maxTextureArrayLayers_$external_prop_getter' : (_this) => _this.maxTextureArrayLayers,
    'io.ygdrasil.webgpu.maxBindGroups_$external_prop_getter' : (_this) => _this.maxBindGroups,
    'io.ygdrasil.webgpu.maxBindGroupsPlusVertexBuffers_$external_prop_getter' : (_this) => _this.maxBindGroupsPlusVertexBuffers,
    'io.ygdrasil.webgpu.maxBindingsPerBindGroup_$external_prop_getter' : (_this) => _this.maxBindingsPerBindGroup,
    'io.ygdrasil.webgpu.maxDynamicUniformBuffersPerPipelineLayout_$external_prop_getter' : (_this) => _this.maxDynamicUniformBuffersPerPipelineLayout,
    'io.ygdrasil.webgpu.maxDynamicStorageBuffersPerPipelineLayout_$external_prop_getter' : (_this) => _this.maxDynamicStorageBuffersPerPipelineLayout,
    'io.ygdrasil.webgpu.maxSampledTexturesPerShaderStage_$external_prop_getter' : (_this) => _this.maxSampledTexturesPerShaderStage,
    'io.ygdrasil.webgpu.maxSamplersPerShaderStage_$external_prop_getter' : (_this) => _this.maxSamplersPerShaderStage,
    'io.ygdrasil.webgpu.maxStorageBuffersPerShaderStage_$external_prop_getter' : (_this) => _this.maxStorageBuffersPerShaderStage,
    'io.ygdrasil.webgpu.maxStorageTexturesPerShaderStage_$external_prop_getter' : (_this) => _this.maxStorageTexturesPerShaderStage,
    'io.ygdrasil.webgpu.maxUniformBuffersPerShaderStage_$external_prop_getter' : (_this) => _this.maxUniformBuffersPerShaderStage,
    'io.ygdrasil.webgpu.maxUniformBufferBindingSize_$external_prop_getter' : (_this) => _this.maxUniformBufferBindingSize,
    'io.ygdrasil.webgpu.maxStorageBufferBindingSize_$external_prop_getter' : (_this) => _this.maxStorageBufferBindingSize,
    'io.ygdrasil.webgpu.minUniformBufferOffsetAlignment_$external_prop_getter' : (_this) => _this.minUniformBufferOffsetAlignment,
    'io.ygdrasil.webgpu.minStorageBufferOffsetAlignment_$external_prop_getter' : (_this) => _this.minStorageBufferOffsetAlignment,
    'io.ygdrasil.webgpu.maxVertexBuffers_$external_prop_getter' : (_this) => _this.maxVertexBuffers,
    'io.ygdrasil.webgpu.maxBufferSize_$external_prop_getter' : (_this) => _this.maxBufferSize,
    'io.ygdrasil.webgpu.maxVertexAttributes_$external_prop_getter' : (_this) => _this.maxVertexAttributes,
    'io.ygdrasil.webgpu.maxVertexBufferArrayStride_$external_prop_getter' : (_this) => _this.maxVertexBufferArrayStride,
    'io.ygdrasil.webgpu.maxInterStageShaderVariables_$external_prop_getter' : (_this) => _this.maxInterStageShaderVariables,
    'io.ygdrasil.webgpu.maxColorAttachments_$external_prop_getter' : (_this) => _this.maxColorAttachments,
    'io.ygdrasil.webgpu.maxColorAttachmentBytesPerSample_$external_prop_getter' : (_this) => _this.maxColorAttachmentBytesPerSample,
    'io.ygdrasil.webgpu.maxComputeWorkgroupStorageSize_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupStorageSize,
    'io.ygdrasil.webgpu.maxComputeInvocationsPerWorkgroup_$external_prop_getter' : (_this) => _this.maxComputeInvocationsPerWorkgroup,
    'io.ygdrasil.webgpu.maxComputeWorkgroupSizeX_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeX,
    'io.ygdrasil.webgpu.maxComputeWorkgroupSizeY_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeY,
    'io.ygdrasil.webgpu.maxComputeWorkgroupSizeZ_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeZ,
    'io.ygdrasil.webgpu.maxComputeWorkgroupsPerDimension_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupsPerDimension,
    'io.ygdrasil.webgpu.requiredFeatures_$external_prop_setter' : (_this, v) => _this.requiredFeatures = v,
    'io.ygdrasil.webgpu.requiredLimits_$external_prop_setter' : (_this, v) => _this.requiredLimits = v,
    'io.ygdrasil.webgpu.defaultQueue_$external_prop_setter' : (_this, v) => _this.defaultQueue = v,
    'io.ygdrasil.webgpu.featureLevel_$external_prop_setter' : (_this, v) => _this.featureLevel = v,
    'io.ygdrasil.webgpu.powerPreference_$external_prop_setter' : (_this, v) => _this.powerPreference = v,
    'io.ygdrasil.webgpu.forceFallbackAdapter_$external_prop_setter' : (_this, v) => _this.forceFallbackAdapter = v,
    'io.ygdrasil.webgpu.xrCompatible_$external_prop_setter' : (_this, v) => _this.xrCompatible = v,
    'io.ygdrasil.webgpu.texture_$external_prop_setter' : (_this, v) => _this.texture = v,
    'io.ygdrasil.webgpu.mipLevel_$external_prop_setter' : (_this, v) => _this.mipLevel = v,
    'io.ygdrasil.webgpu.origin_$external_prop_setter' : (_this, v) => _this.origin = v,
    'io.ygdrasil.webgpu.aspect_$external_prop_setter' : (_this, v) => _this.aspect = v,
    'io.ygdrasil.webgpu.offset_$external_prop_setter' : (_this, v) => _this.offset = v,
    'io.ygdrasil.webgpu.bytesPerRow_$external_prop_setter' : (_this, v) => _this.bytesPerRow = v,
    'io.ygdrasil.webgpu.rowsPerImage_$external_prop_setter' : (_this, v) => _this.rowsPerImage = v,
    'io.ygdrasil.webgpu.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'io.ygdrasil.webgpu.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'io.ygdrasil.webgpu.depthOrArrayLayers_$external_prop_setter' : (_this, v) => _this.depthOrArrayLayers = v,
    'io.ygdrasil.webgpu.r_$external_prop_setter' : (_this, v) => _this.r = v,
    'io.ygdrasil.webgpu.g_$external_prop_setter' : (_this, v) => _this.g = v,
    'io.ygdrasil.webgpu.b_$external_prop_setter' : (_this, v) => _this.b = v,
    'io.ygdrasil.webgpu.a_$external_prop_setter' : (_this, v) => _this.a = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.dimension_$external_prop_setter' : (_this, v) => _this.dimension = v,
    'io.ygdrasil.webgpu.aspect_$external_prop_setter_1' : (_this, v) => _this.aspect = v,
    'io.ygdrasil.webgpu.baseMipLevel_$external_prop_setter' : (_this, v) => _this.baseMipLevel = v,
    'io.ygdrasil.webgpu.mipLevelCount_$external_prop_setter' : (_this, v) => _this.mipLevelCount = v,
    'io.ygdrasil.webgpu.baseArrayLayer_$external_prop_setter' : (_this, v) => _this.baseArrayLayer = v,
    'io.ygdrasil.webgpu.arrayLayerCount_$external_prop_setter' : (_this, v) => _this.arrayLayerCount = v,
    'io.ygdrasil.webgpu.beginRenderPass_$external_fun' : (_this, p0) => _this.beginRenderPass(p0),
    'io.ygdrasil.webgpu.copyBufferToBuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.copyBufferToBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.copyBufferToBuffer_$external_fun_1' : (_this, p0, p1, p2, p3, p4) => _this.copyBufferToBuffer(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.copyTextureToTexture_$external_fun' : (_this, p0, p1, p2) => _this.copyTextureToTexture(p0, p1, p2),
    'io.ygdrasil.webgpu.resolveQuerySet_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.resolveQuerySet(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.finish_$external_fun' : (_this, ) => _this.finish(),
    'io.ygdrasil.webgpu.finish_$external_fun_1' : (_this, p0) => _this.finish(p0),
    'io.ygdrasil.webgpu.code_$external_prop_setter' : (_this, v) => _this.code = v,
    'io.ygdrasil.webgpu.compilationHints_$external_prop_setter' : (_this, v) => _this.compilationHints = v,
    'io.ygdrasil.webgpu.bindGroupLayouts_$external_prop_setter' : (_this, v) => _this.bindGroupLayouts = v,
    'io.ygdrasil.webgpu.vertex_$external_prop_setter' : (_this, v) => _this.vertex = v,
    'io.ygdrasil.webgpu.primitive_$external_prop_setter' : (_this, v) => _this.primitive = v,
    'io.ygdrasil.webgpu.depthStencil_$external_prop_setter' : (_this, v) => _this.depthStencil = v,
    'io.ygdrasil.webgpu.multisample_$external_prop_setter' : (_this, v) => _this.multisample = v,
    'io.ygdrasil.webgpu.fragment_$external_prop_setter' : (_this, v) => _this.fragment = v,
    'io.ygdrasil.webgpu.size_$external_prop_setter' : (_this, v) => _this.size = v,
    'io.ygdrasil.webgpu.usage_$external_prop_setter' : (_this, v) => _this.usage = v,
    'io.ygdrasil.webgpu.mappedAtCreation_$external_prop_setter' : (_this, v) => _this.mappedAtCreation = v,
    'io.ygdrasil.webgpu.size_$external_prop_setter_1' : (_this, v) => _this.size = v,
    'io.ygdrasil.webgpu.mipLevelCount_$external_prop_setter_1' : (_this, v) => _this.mipLevelCount = v,
    'io.ygdrasil.webgpu.sampleCount_$external_prop_setter' : (_this, v) => _this.sampleCount = v,
    'io.ygdrasil.webgpu.dimension_$external_prop_setter_1' : (_this, v) => _this.dimension = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_1' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.usage_$external_prop_setter_1' : (_this, v) => _this.usage = v,
    'io.ygdrasil.webgpu.viewFormats_$external_prop_setter' : (_this, v) => _this.viewFormats = v,
    'io.ygdrasil.webgpu.layout_$external_prop_setter' : (_this, v) => _this.layout = v,
    'io.ygdrasil.webgpu.entries_$external_prop_setter' : (_this, v) => _this.entries = v,
    'io.ygdrasil.webgpu.addressModeU_$external_prop_setter' : (_this, v) => _this.addressModeU = v,
    'io.ygdrasil.webgpu.addressModeV_$external_prop_setter' : (_this, v) => _this.addressModeV = v,
    'io.ygdrasil.webgpu.addressModeW_$external_prop_setter' : (_this, v) => _this.addressModeW = v,
    'io.ygdrasil.webgpu.magFilter_$external_prop_setter' : (_this, v) => _this.magFilter = v,
    'io.ygdrasil.webgpu.minFilter_$external_prop_setter' : (_this, v) => _this.minFilter = v,
    'io.ygdrasil.webgpu.mipmapFilter_$external_prop_setter' : (_this, v) => _this.mipmapFilter = v,
    'io.ygdrasil.webgpu.lodMinClamp_$external_prop_setter' : (_this, v) => _this.lodMinClamp = v,
    'io.ygdrasil.webgpu.lodMaxClamp_$external_prop_setter' : (_this, v) => _this.lodMaxClamp = v,
    'io.ygdrasil.webgpu.compare_$external_prop_setter' : (_this, v) => _this.compare = v,
    'io.ygdrasil.webgpu.maxAnisotropy_$external_prop_setter' : (_this, v) => _this.maxAnisotropy = v,
    'io.ygdrasil.webgpu.entries_$external_prop_setter_1' : (_this, v) => _this.entries = v,
    'io.ygdrasil.webgpu.destroy_$external_fun_3' : (_this, ) => _this.destroy(),
    'io.ygdrasil.webgpu.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'io.ygdrasil.webgpu.count_$external_prop_setter' : (_this, v) => _this.count = v,
    'io.ygdrasil.webgpu.x_$external_prop_setter' : (_this, v) => _this.x = v,
    'io.ygdrasil.webgpu.y_$external_prop_setter' : (_this, v) => _this.y = v,
    'io.ygdrasil.webgpu.z_$external_prop_setter' : (_this, v) => _this.z = v,
    'io.ygdrasil.webgpu.colorAttachments_$external_prop_setter' : (_this, v) => _this.colorAttachments = v,
    'io.ygdrasil.webgpu.depthStencilAttachment_$external_prop_setter' : (_this, v) => _this.depthStencilAttachment = v,
    'io.ygdrasil.webgpu.maxDrawCount_$external_prop_setter' : (_this, v) => _this.maxDrawCount = v,
    'io.ygdrasil.webgpu.entryPoint_$external_prop_setter' : (_this, v) => _this.entryPoint = v,
    'io.ygdrasil.webgpu.layout_$external_prop_setter_1' : (_this, v) => _this.layout = v,
    'io.ygdrasil.webgpu.buffers_$external_prop_setter' : (_this, v) => _this.buffers = v,
    'io.ygdrasil.webgpu.topology_$external_prop_setter' : (_this, v) => _this.topology = v,
    'io.ygdrasil.webgpu.stripIndexFormat_$external_prop_setter' : (_this, v) => _this.stripIndexFormat = v,
    'io.ygdrasil.webgpu.frontFace_$external_prop_setter' : (_this, v) => _this.frontFace = v,
    'io.ygdrasil.webgpu.cullMode_$external_prop_setter' : (_this, v) => _this.cullMode = v,
    'io.ygdrasil.webgpu.unclippedDepth_$external_prop_setter' : (_this, v) => _this.unclippedDepth = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_2' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.depthWriteEnabled_$external_prop_setter' : (_this, v) => _this.depthWriteEnabled = v,
    'io.ygdrasil.webgpu.depthCompare_$external_prop_setter' : (_this, v) => _this.depthCompare = v,
    'io.ygdrasil.webgpu.stencilFront_$external_prop_setter' : (_this, v) => _this.stencilFront = v,
    'io.ygdrasil.webgpu.stencilBack_$external_prop_setter' : (_this, v) => _this.stencilBack = v,
    'io.ygdrasil.webgpu.stencilReadMask_$external_prop_setter' : (_this, v) => _this.stencilReadMask = v,
    'io.ygdrasil.webgpu.stencilWriteMask_$external_prop_setter' : (_this, v) => _this.stencilWriteMask = v,
    'io.ygdrasil.webgpu.depthBias_$external_prop_setter' : (_this, v) => _this.depthBias = v,
    'io.ygdrasil.webgpu.depthBiasSlopeScale_$external_prop_setter' : (_this, v) => _this.depthBiasSlopeScale = v,
    'io.ygdrasil.webgpu.depthBiasClamp_$external_prop_setter' : (_this, v) => _this.depthBiasClamp = v,
    'io.ygdrasil.webgpu.targets_$external_prop_setter' : (_this, v) => _this.targets = v,
    'io.ygdrasil.webgpu.count_$external_prop_setter_1' : (_this, v) => _this.count = v,
    'io.ygdrasil.webgpu.mask_$external_prop_setter' : (_this, v) => _this.mask = v,
    'io.ygdrasil.webgpu.alphaToCoverageEnabled_$external_prop_setter' : (_this, v) => _this.alphaToCoverageEnabled = v,
    'io.ygdrasil.webgpu.arrayStride_$external_prop_setter' : (_this, v) => _this.arrayStride = v,
    'io.ygdrasil.webgpu.stepMode_$external_prop_setter' : (_this, v) => _this.stepMode = v,
    'io.ygdrasil.webgpu.attributes_$external_prop_setter' : (_this, v) => _this.attributes = v,
    'io.ygdrasil.webgpu.compare_$external_prop_setter_1' : (_this, v) => _this.compare = v,
    'io.ygdrasil.webgpu.failOp_$external_prop_setter' : (_this, v) => _this.failOp = v,
    'io.ygdrasil.webgpu.depthFailOp_$external_prop_setter' : (_this, v) => _this.depthFailOp = v,
    'io.ygdrasil.webgpu.passOp_$external_prop_setter' : (_this, v) => _this.passOp = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_3' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.blend_$external_prop_setter' : (_this, v) => _this.blend = v,
    'io.ygdrasil.webgpu.writeMask_$external_prop_setter' : (_this, v) => _this.writeMask = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_4' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.offset_$external_prop_setter_1' : (_this, v) => _this.offset = v,
    'io.ygdrasil.webgpu.shaderLocation_$external_prop_setter' : (_this, v) => _this.shaderLocation = v,
    'io.ygdrasil.webgpu.color_$external_prop_setter' : (_this, v) => _this.color = v,
    'io.ygdrasil.webgpu.alpha_$external_prop_setter' : (_this, v) => _this.alpha = v,
    'io.ygdrasil.webgpu.operation_$external_prop_setter' : (_this, v) => _this.operation = v,
    'io.ygdrasil.webgpu.srcFactor_$external_prop_setter' : (_this, v) => _this.srcFactor = v,
    'io.ygdrasil.webgpu.dstFactor_$external_prop_setter' : (_this, v) => _this.dstFactor = v,
    'io.ygdrasil.webgpu.module_$external_prop_setter' : (_this, v) => _this.module = v,
    'io.ygdrasil.webgpu.entryPoint_$external_prop_setter_1' : (_this, v) => _this.entryPoint = v,
    'io.ygdrasil.webgpu.binding_$external_prop_setter' : (_this, v) => _this.binding = v,
    'io.ygdrasil.webgpu.resource_$external_prop_setter' : (_this, v) => _this.resource = v,
    'io.ygdrasil.webgpu.buffer_$external_prop_setter' : (_this, v) => _this.buffer = v,
    'io.ygdrasil.webgpu.offset_$external_prop_setter_2' : (_this, v) => _this.offset = v,
    'io.ygdrasil.webgpu.size_$external_prop_setter_2' : (_this, v) => _this.size = v,
    'io.ygdrasil.webgpu.binding_$external_prop_setter_1' : (_this, v) => _this.binding = v,
    'io.ygdrasil.webgpu.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
    'io.ygdrasil.webgpu.buffer_$external_prop_setter_1' : (_this, v) => _this.buffer = v,
    'io.ygdrasil.webgpu.sampler_$external_prop_setter' : (_this, v) => _this.sampler = v,
    'io.ygdrasil.webgpu.texture_$external_prop_setter_1' : (_this, v) => _this.texture = v,
    'io.ygdrasil.webgpu.storageTexture_$external_prop_setter' : (_this, v) => _this.storageTexture = v,
    'io.ygdrasil.webgpu.type_$external_prop_setter_1' : (_this, v) => _this.type = v,
    'io.ygdrasil.webgpu.hasDynamicOffset_$external_prop_setter' : (_this, v) => _this.hasDynamicOffset = v,
    'io.ygdrasil.webgpu.minBindingSize_$external_prop_setter' : (_this, v) => _this.minBindingSize = v,
    'io.ygdrasil.webgpu.type_$external_prop_setter_2' : (_this, v) => _this.type = v,
    'io.ygdrasil.webgpu.sampleType_$external_prop_setter' : (_this, v) => _this.sampleType = v,
    'io.ygdrasil.webgpu.viewDimension_$external_prop_setter' : (_this, v) => _this.viewDimension = v,
    'io.ygdrasil.webgpu.multisampled_$external_prop_setter' : (_this, v) => _this.multisampled = v,
    'io.ygdrasil.webgpu.access_$external_prop_setter' : (_this, v) => _this.access = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_5' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.viewDimension_$external_prop_setter_1' : (_this, v) => _this.viewDimension = v,
    'io.ygdrasil.webgpu.view_$external_prop_setter' : (_this, v) => _this.view = v,
    'io.ygdrasil.webgpu.depthSlice_$external_prop_setter' : (_this, v) => _this.depthSlice = v,
    'io.ygdrasil.webgpu.resolveTarget_$external_prop_setter' : (_this, v) => _this.resolveTarget = v,
    'io.ygdrasil.webgpu.clearValue_$external_prop_setter' : (_this, v) => _this.clearValue = v,
    'io.ygdrasil.webgpu.loadOp_$external_prop_setter' : (_this, v) => _this.loadOp = v,
    'io.ygdrasil.webgpu.storeOp_$external_prop_setter' : (_this, v) => _this.storeOp = v,
    'io.ygdrasil.webgpu.view_$external_prop_setter_1' : (_this, v) => _this.view = v,
    'io.ygdrasil.webgpu.depthClearValue_$external_prop_setter' : (_this, v) => _this.depthClearValue = v,
    'io.ygdrasil.webgpu.depthLoadOp_$external_prop_setter' : (_this, v) => _this.depthLoadOp = v,
    'io.ygdrasil.webgpu.depthStoreOp_$external_prop_setter' : (_this, v) => _this.depthStoreOp = v,
    'io.ygdrasil.webgpu.depthReadOnly_$external_prop_setter' : (_this, v) => _this.depthReadOnly = v,
    'io.ygdrasil.webgpu.stencilClearValue_$external_prop_setter' : (_this, v) => _this.stencilClearValue = v,
    'io.ygdrasil.webgpu.stencilLoadOp_$external_prop_setter' : (_this, v) => _this.stencilLoadOp = v,
    'io.ygdrasil.webgpu.stencilStoreOp_$external_prop_setter' : (_this, v) => _this.stencilStoreOp = v,
    'io.ygdrasil.webgpu.stencilReadOnly_$external_prop_setter' : (_this, v) => _this.stencilReadOnly = v,
    'io.ygdrasil.webgpu.device_$external_prop_setter' : (_this, v) => _this.device = v,
    'io.ygdrasil.webgpu.format_$external_prop_setter_6' : (_this, v) => _this.format = v,
    'io.ygdrasil.webgpu.usage_$external_prop_setter_2' : (_this, v) => _this.usage = v,
    'io.ygdrasil.webgpu.viewFormats_$external_prop_setter_1' : (_this, v) => _this.viewFormats = v,
    'io.ygdrasil.webgpu.colorSpace_$external_prop_setter' : (_this, v) => _this.colorSpace = v,
    'io.ygdrasil.webgpu.toneMapping_$external_prop_setter' : (_this, v) => _this.toneMapping = v,
    'io.ygdrasil.webgpu.alphaMode_$external_prop_setter' : (_this, v) => _this.alphaMode = v,
    'io.ygdrasil.webgpu.mode_$external_prop_setter' : (_this, v) => _this.mode = v,
    'io.ygdrasil.webgpu.setBindGroup_$external_fun' : (_this, p0, p1) => _this.setBindGroup(p0, p1),
    'io.ygdrasil.webgpu.setBindGroup_$external_fun_1' : (_this, p0, p1, p2) => _this.setBindGroup(p0, p1, p2),
    'io.ygdrasil.webgpu.setPipeline_$external_fun' : (_this, p0) => _this.setPipeline(p0),
    'io.ygdrasil.webgpu.setIndexBuffer_$external_fun' : (_this, p0, p1, p2) => _this.setIndexBuffer(p0, p1, p2),
    'io.ygdrasil.webgpu.setIndexBuffer_$external_fun_1' : (_this, p0, p1, p2, p3) => _this.setIndexBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.setVertexBuffer_$external_fun' : (_this, p0, p1, p2) => _this.setVertexBuffer(p0, p1, p2),
    'io.ygdrasil.webgpu.setVertexBuffer_$external_fun_1' : (_this, p0, p1, p2, p3) => _this.setVertexBuffer(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.draw_$external_fun' : (_this, p0, p1, p2, p3) => _this.draw(p0, p1, p2, p3),
    'io.ygdrasil.webgpu.drawIndexed_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.drawIndexed(p0, p1, p2, p3, p4),
    'io.ygdrasil.webgpu.label_$external_prop_setter' : (_this, v) => _this.label = v,
    'io.ygdrasil.webgpu.getBindGroupLayout_$external_fun' : (_this, p0) => _this.getBindGroupLayout(p0),
    'io.ygdrasil.webgpu.layout_$external_prop_setter_2' : (_this, v) => _this.layout = v,
    'io.ygdrasil.webgpu.toJsNumber' : (x) => x,
    'io.ygdrasil.webgpu.toJsNumber_1' : (x) => x,
    'io.ygdrasil.webgpu.toJsNumber_2' : (x) => x,
    'io.ygdrasil.webgpu.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'io.ygdrasil.webgpu.error_$external_prop_getter' : (_this) => _this.error,
    'io.ygdrasil.webgpu.mapper.isGPUValidationError' : (error) => error instanceof GPUValidationError,
    'io.ygdrasil.webgpu.mapper.isGPUInternalError' : (error) => error instanceof GPUInternalError,
    'io.ygdrasil.webgpu.mapper.isGPUOutOfMemoryError' : (error) => error instanceof GPUOutOfMemoryError,
    'com.awakekt.awake.webgpu.copyOfLinearMemory' : (memory, byteOffset, byteSize) => memory.buffer.slice(byteOffset, byteOffset + byteSize),
    'com.awakekt.awake.webgpu.application.browserExposesWebGpu' : () => typeof navigator !== 'undefined' && navigator.gpu != null,
    'com.awakekt.awake.webgpu.application.reportWebGpuRuntimeFailure' : (message) => console.error(message),
    'com.awakekt.awake.webgpu.renderer.hasCopyExternalImage' : (queue) => typeof queue.copyExternalImageToTexture === 'function',
    'com.awakekt.awake.webgpu.renderer.copyImageBitmap' : (queue, bitmap, texture, width, height) => queue.copyExternalImageToTexture(
            { source: bitmap, flipY: true },
            { texture: texture, premultipliedAlpha: false },
            [width, height],
        ),
    'com.awakekt.awake.webgpu.renderer.writeFromLinearMemory' : (queue, buffer, byteOffset, byteSize) => queue.writeBuffer(buffer, 0, wasmExports.memory.buffer, byteOffset, byteSize)
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
};
    